var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkinA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 309,
    viewBox: "0 0 248 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7933 181.706C49.9971 183.008 46.4835 184.214 43.3846 185.262C16.8462 194.239 8 295.413 8 309H123H239C239 295.413 230.077 194.239 203.308 185.262C200.182 184.214 196.638 183.008 192.808 181.706C170.404 174.083 138.241 163.141 123 161C107.89 163.141 76.0046 174.083 53.7933 181.706Z",
    className: "Skin"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 279H53.9774L54 306C42.4389 309.612 17.3937 301.602 9 294L10.5 279Z",
    fill: "#CF8181",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 279H193.023L193 306C204.561 309.612 229.606 301.602 238 294L236.5 279Z",
    fill: "#CF8181",
    fillOpacity: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 134H146V181.914C138.08 190.56 108.02 189.479 101 181.914V134Z",
    className: "Skin"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101 134.587H146V150.587C133 158.587 113 158.587 101 150.587V134.587Z",
    fill: "#CF8181",
    fillOpacity: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86 94C86 104.493 77.7553 113 67.5849 113C57.4145 113 54 104.493 54 94C54 83.5066 57.4145 75 67.5849 75C77.7553 75 86 83.5066 86 94Z",
    className: "Skin"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86 94C86 104.493 77.7553 113 67.5849 113C57.4145 113 54 104.493 54 94C54 83.5066 57.4145 75 67.5849 75C77.7553 75 86 83.5066 86 94Z",
    fill: "#CF8181",
    fillOpacity: 0.5
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162 94C162 104.493 170.245 113 180.415 113C190.585 113 194 104.493 194 94C194 83.5066 190.585 75 180.415 75C170.245 75 162 83.5066 162 94Z",
    className: "Skin"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162 94C162 104.493 170.245 113 180.415 113C190.585 113 194 104.493 194 94C194 83.5066 190.585 75 180.415 75C170.245 75 162 83.5066 162 94Z",
    fill: "#CF8181",
    fillOpacity: 0.5
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184 71.3062C184 117.689 164.169 148 124 148C83.8312 148 64 117.689 64 71.3062C64 24.9238 83.8312 0 124 0C164.169 0 184 24.9238 184 71.3062Z",
    className: "Skin"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.424 95.0292L120.738 80.2561C122.262 77.1763 126.668 77.2701 128.061 80.412L134.649 95.2672C135.475 97.1304 134.8 99.3202 133.07 100.388L126.571 104.398C125.331 105.164 123.776 105.201 122.5 104.496L115.097 100.404C113.196 99.3523 112.458 96.9815 113.424 95.0292Z",
    fill: "#CF8181",
    fillOpacity: 0.5
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "Chest",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0168 171.064C81.4963 170.121 83.449 170.119 85.7632 170.712C86.9078 185.723 101.19 193.778 123.606 193.778C145.785 193.778 160.122 185.894 161.54 171.187C162.878 170.5 166.323 170.115 167.997 171.387C178.734 174.82 189.545 178.461 198.81 181.58L198.811 181.581C202.941 182.971 206.765 184.259 210.137 185.378C229.707 191.874 241.474 245.961 246 283.311C240.484 288.744 225.025 295.451 195.346 295.451C195.346 298.156 195.221 300.141 195.096 302.135L195.096 302.135C194.97 304.146 194.844 306.165 194.844 308.941L123.5 309L52.3521 308.941C52.3521 306.165 52.2256 304.271 52.0996 302.386C51.9747 300.517 51.8503 298.656 51.8503 295.951C22.1713 295.951 6.51633 288.744 1 283.311C5.52623 245.961 17.2934 191.874 36.8633 185.378C40.2353 184.259 44.0584 182.972 48.189 181.581L48.1899 181.58C57.7462 178.362 68.9481 174.59 80.0168 171.064Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "Arms",
    d: "M31.1271 188.775C14.972 202.716 5.06533 249.764 1 283.311C6.1703 288.975 22.6713 296.635 52.1098 296.701C51.3811 269.932 51.1479 229.153 53.1801 225.566L53.2004 225.531C52.0143 216.028 44.252 204.718 37.5 196C35.2774 193.13 33 191 31.1271 188.775Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "ArmsMirrored",
    d: "M215.5 188.5C232 201.5 242.135 248.989 246.2 283.536C241.03 288.2 224.529 295.86 195.09 295.926C195.819 269.157 196.052 228.378 194.02 224.791L194 224.756C195.186 215.253 202.948 203.943 209.7 195.225C211.923 192.355 213.627 190.725 215.5 188.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "Shoulders",
    d: "M37.6175 184.621C49.4611 180.56 63.565 175.529 79.7393 170.661C80.7428 170.162 83.8535 169.464 86.2618 170.661C86.7636 179.634 92.9921 186.451 101.02 189.941C90.6116 195.716 66.4656 210.814 53.1475 225C51.1072 215.872 39 197.331 30.7773 188.928C32.9005 186.814 35.2255 185.441 37.6175 184.621Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "ShouldersMirrored",
    d: "M209.402 184.621C197.558 180.56 183.454 175.529 167.28 170.661C166.277 170.162 163.166 169.464 160.758 170.661C160.256 179.634 154.027 186.451 146 189.941C156.408 195.716 180.554 210.814 193.872 225C195.912 215.872 208.02 197.331 216.242 188.928C214.119 186.814 211.794 185.441 209.402 184.621Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "Sleeves",
    d: "M52.2242 297.356C22.595 297.356 6.18035 289.477 0.673282 284C0.171759 281.5 0.715146 276.568 2.00344 273.932C9.00993 280.002 30.1433 285.263 52.2242 285.891V297.356Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "SleevesMirrored",
    d: "M194.843 296.5C224.472 296.5 240.493 290.431 246 284.954C247.003 282.95 246.501 276.437 244.995 273.932C237.989 280.002 217.426 285.372 195.345 286L194.843 296.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinA);
export default __webpack_public_path__ + "static/media/Skin A.08a897421a06d36d034ce9043ebb6bff.svg";
export { ForwardRef as ReactComponent };